const downloadReportsToast = (state = null, action) => {
  if (action.type === "SET_GENERATE_RECEIPT_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_GENERATE_RECEIPT_TOAST": {
  //     return action.payload;
  //   }
  //   default: {
  //     return state;
  //   }
  // }
};

export default downloadReportsToast;
